export default {
  analytics: {},
  users: {},
  suggestions: [],
  currentSchool: {
    city: "Enter Here",
    clever_id: null,
    district_id: null,
    country: "Enter Here",
    has_new_suggestions: null,
    id: "",
    invites: [],
    is_paid: null,
    membership: [],
    name: "",
    new_suggestions: [],
    phone_number: null,
    street_address: "Enter Here",
    thumbnail_url: null,
    updated_at: "2021-04-29T14:47:47.182Z",
    website: null,
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/adminPortal/state.js